import React from 'react';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import { grey } from '@material-ui/core/colors';
import { ListItem } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
// components
import Appbar from './Appbar';
import ChatItem from './ChatItem';
import ChatInput from './ChatInput';
import IntroCarousel from './IntroCarousel';
//models
import Message, { MessageDirection, MessageStatus, MessageType } from '../models/Message';
import Conversation, { Option } from '../models/Conversation';
import { errorMessage } from '../models/Constants';
//services
import { sendMessage } from '../services/WatsonService';
import { parseMessageText, parseMessageTextLink, parseMessageOption, parseMessageCardCarousel } from '../services/ConversationParser';

let count = 0;
export default class ChatArea extends React.Component <{closeHandler:any}, { initBot:boolean, inConversation: boolean, messages:Message[], conversation?: Conversation, showIntro?:boolean, elevateAppbar?:boolean }> { 
  messagesEndRef:any = React.createRef(); //This was use to scroll to bottom. Removed as now message list is cleared on new message.
  constructor(props:any) {
    super(props);
    this.state = {
      inConversation: false,
      messages: [],
      showIntro: true,
      elevateAppbar: false,
      initBot: false, //This state variable is used to show/hide input box and send button area. false:hide, true:show
      
      /* 
      * Following context is initialized with values which will be displayed 
      * on app load and in turn will trigger Hello message for conversation initialization
      */
      conversation: ({
        "context": {
            "display_option": ["option"]
        },
        "genericResponses": [{
            "responseType": "text",
            "response": {
              "title": "Please click below option to start conversation",
              "options": [{
                  "label": "Hello",
                  "value": "Hello",
                  "isNew": false
                }]
            }
        }]
      } as Conversation)
    };
  }
  
  
  componentDidMount(){
    /**
     * Old code is removed and thebackup is saved in ChatArea_backup_startconversation file.
     */
    this.addConversationToMessage((this.state.conversation)!)
    this.scrollToBottom();  //This is used to scroll to bottom.
    if(!this.state.showIntro) { this.scrollToBottom(); } //This was use to scroll to bottom. Removed as now message list is cleared on new message.
  }

  componentDidUpdate() {
    
    //console.log("COUNT: "+ count);
    if(count === 0){
      count++;
    }else{
      this.scrollToBottom();  //This is used to scroll to bottom.
    }
    
    if(!this.state.showIntro) { this.scrollToBottom(); } //This was use to scroll to bottom. Removed as now message list is cleared on new message.
  }

  scrollToBottom = () => {
    //this.messagesEndRef.scrollIntoView({ behavior: "smooth" });
    this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });  //This is used to scroll to bottom.
  }

  actions = {
    quickResponseHandler: (messageIndex:number, responseValue:any)=>{
      if(this.state.showIntro){
        this.setState({showIntro: false,  elevateAppbar: true});
      }
     
      const tempMessages = [...this.state.messages];
      
      //console.log("quickResponseHandler TEMPMSG : "+JSON.stringify(tempMessages));
      const responseItemIndex:number = tempMessages.findIndex(msg => {
        return msg.messageIndex === messageIndex
      }); 
      //console.log("responseItemIndex 1 :"+responseItemIndex);
      
      const registeredResponseIndex:number = tempMessages[responseItemIndex].messageData.findIndex((opt:Option) => {
        return (opt.value).toLowerCase() === (responseValue as string).toLowerCase()
      })
      const registeredResponse:Option = {...tempMessages[responseItemIndex].messageData[registeredResponseIndex]} as Option
      
            
      /*#################################################################*/

      /*
      * This block of code is written to handle the chatbot context in case
      * someone tried to change the topic/context. In case of change in 
      * context the "sameContext" flag will be "False" otherwise True
      * and if "sameContext is False" we are taking "lastInput" as 
      * a message/input for the chatbot to give proper response
      */
      let msgToSend  = registeredResponse.label;
      
      
      if(this.state.conversation?.context.sameContext === false && registeredResponse.label.toLowerCase() === "yes")
        msgToSend = "Yes";
      
      /*#################################################################*/

      const newMsg = {
        messageIndex:responseItemIndex+1,
        messageDirection:MessageDirection.SENT,
        messageStatus:MessageStatus.SENDING,
        messageType: MessageType.TEXT,
        messageData: msgToSend
      }
      //tempMessages[responseItemIndex] = newMsg;
      tempMessages.push(newMsg);

      let conv:Conversation = {...this.state.conversation}
      //console.log(conv)
      
      
      //console.log(registeredResponse.label);

      // if(registeredResponse.label === "Talk to Agent"){
      //   (window.parent.document.getElementById("chatIframe") as HTMLInputElement).src = "https://ams.techmahindra.com/boblivechat/livechat.html"; //Set TechM Chat Module
      // }else{
        sendMessage(this.state.conversation?.context.sameContext === false && registeredResponse.label.toLowerCase() === "yes"?
                  this.state.conversation?.context.lastInput:registeredResponse.label, conv.context)
                  // Above condition Added on 04 October for handling the Yes/No digression on both quick response
        .then(conversation => {
          const newConv: Conversation = conversation as Conversation;
          let lastSendingMsg: Message = tempMessages[tempMessages.length-1];
          lastSendingMsg.messageStatus = MessageStatus.SENT;
          tempMessages[tempMessages.length-1] = lastSendingMsg;
        // console.log("SKYY: "+ JSON.stringify(tempMessages));
          this.setState({conversation: newConv, messages: tempMessages});
        // console.log(registeredResponse.label)

        /*
        * Below condition setthe initBot to true after Hello
        * message is sent to watson and reply is received
        */
          if(newConv.context.conversation_id){
            this.setState({initBot:true});
          }

          //console.log("LOKIIII : "+ JSON.stringify(newConv));
          this.addConversationToMessage(newConv);   
        })
        .catch(
          // error => console.log(error)
        );

      // }

      
    },

    sentMessageStatusHandler: () => {

    },

    chatInputSendHandler: (value:any) => {
      if(this.state.showIntro){
        this.setState({showIntro: false,  elevateAppbar: true});
      }
      const tempMessages = [...this.state.messages];
      
      const newMsg = {
        messageIndex: tempMessages.length,
        messageDirection:MessageDirection.SENT,
        messageStatus:MessageStatus.SENDING,
        messageType: MessageType.TEXT,
        messageData: value
      }
      tempMessages.push(newMsg);
      this.setState({messages: tempMessages});
     // alert(value);

      
      let conv:Conversation = {...this.state.conversation}
      //alert(typeof value)
      sendMessage(this.state.conversation?.context.sameContext === false && value.toLowerCase() === "yes"?
                  this.state.conversation?.context.lastInput:value, conv.context)
                  // Above condition added on 04 October for handling the Yes/No digression on both input and quick response above
      .then(conversation => {
        const newConv: Conversation = conversation as Conversation;
        let lastSendingMsg: Message = tempMessages[tempMessages.length-1];
        lastSendingMsg.messageStatus = MessageStatus.SENT;
        tempMessages[tempMessages.length-1] = lastSendingMsg;
        this.setState({conversation: newConv, messages: tempMessages});
        this.addConversationToMessage((conversation as Conversation)!);
      })
      .catch(
        // error => console.log(error)
      );
    },


    
    // resetHandler: () => {
    //   this.setState({conversation: undefined, messages: []})

    //   startConversation()
    //     .then(conversation => {
    //       this.setState({conversation: (conversation as Conversation)!})
    //       this.addConversationToMessage((conversation as Conversation)!)
    //     })
    //     .catch(error => console.log(error));
    //   this.scrollToBottom();
    // },

    // closeHandler: () => {
    //   console.log("**** CLOSE HANDLER ****");
    // },

    introScrollCallback: (previousY:number, currentY:number) => {
      if(this.state.showIntro) {
        if(currentY > previousY) {
          this.setState({elevateAppbar: false})
        }else if(currentY < previousY) {
          this.setState({elevateAppbar: true})
        }
      }
    }

  }

  IntroComponent = () => {
    if(!this.state.showIntro){
      return null
    }else{
      return <IntroCarousel scrollCallback = {this.actions.introScrollCallback} />
    }
  }

  render(){
    document.title = "ADI";
    return (
      <div style={{margin:0, padding:0, flexGrow:1, width:"100%", height:"100%"}} >
        <CssBaseline />
        <Appbar elevate = {this.state.elevateAppbar} /*resetHandler={this.actions.resetHandler} closeHandler={this.actions.closeHandler}*/
        conv={this.state.conversation} />
        <Box flexGrow={1}>     
          <this.IntroComponent />
        </Box>
        <Box flexGrow={1} marginBottom={8}>
          <List style={{color: grey[900], flexGrow:1, width:"100%", height:"100%"}}>
            {this.state.messages.map((message) => {
              return (
                <Box width={1} key={message.messageIndex}> {/* Key attribute added on 30-AUG-2022 */}
                  <ListItem key={message.messageIndex}>
                    <ChatItem itemIndex={message.messageIndex} message={message} actions={this.actions}/>
                  </ListItem>
                </Box>
              )
            })}
           <div ref={this.messagesEndRef} />  {/* Used to scroll to bottom*/}
          </List>
        </Box>
        <div style={{height: 20}}></div>
        {this.state.initBot?<ChatInput chatInputHandler={this.actions.chatInputSendHandler} />:""}
      </div>
    );
  }

  addConversationToMessage(conversation:Conversation){
        
    //const tempMessages = [...this.state.messages]; //comment this if uncommenting below logic.
    //logic to remove all previous message but 1, and clear screen. Last user input is kept.
    //console.log("addConversationToMessage : "+JSON.stringify(this.state.messages));

    const tempMessages = [...this.state.messages];//.reverse();
    //console.log("addConversationToMessage TEMPMSG : "+JSON.stringify(tempMessages));
    //console.log(tempMessages.length);
    // while (tempMessages.length > 1) {
    //   tempMessages.pop()
    // }
    if(tempMessages.length > 0){
      const repMsg:Message = tempMessages[0];
      repMsg.messageIndex = 0;
      tempMessages[0] = repMsg;
    }
    //logic ends here
    //console.log("GUDDDUUU : "+ JSON.stringify(conversation));
    let convIndex = 0;
    //Added to handle options error
    if(!conversation.context.display_option){
      conversation.context.display_option = ["undefined"];
    }
    
    conversation.context.display_option.forEach((dispopt:any) => {
      //console.log("SKY : "+dispopt);
      switch(dispopt){
        case "text":
          tempMessages.push(parseMessageText(conversation.genericResponses![convIndex],tempMessages.length));
          convIndex += 1;
          break;
        case "text_link":
          tempMessages.push(parseMessageTextLink(conversation.genericResponses![convIndex],tempMessages.length));
          convIndex += 1;
          break;
        case "option": 
          parseMessageOption(conversation.genericResponses![convIndex],tempMessages.length).forEach(msg => {
            tempMessages.push(msg);
          });
          convIndex += 1;
          break;
        case "card_carousel":
          tempMessages.push(parseMessageCardCarousel(conversation.genericResponses!, convIndex, conversation.context.sba!.length,tempMessages.length));
          convIndex += conversation.context.sba!.length*2;
          break;
        case "undefined":default:
          tempMessages.push({
            //messageData: errorMessage[Math.floor(Math.random() * errorMessage.length)],
            messageData: errorMessage[crypto.getRandomValues(new Uint8Array(1))[0]],
            messageDirection: MessageDirection.RECEIVED,
            messageIndex: tempMessages.length,
            messageStatus: MessageStatus.RECEIVED,
            messageType: MessageType.TEXT
          } as Message);
          convIndex += 1;
          break;
      }
    });
    this.setState({messages: tempMessages});
  }
}